<template src="./filtercomponent.template.html"></template>

<script>
    import moment from "moment-timezone";
    export default {
        name: "filtercomponent",
        props: ['default', 'sidebar', 'toggleFilterPanel', 'parentCallback'],

        data() {
            return {
                showPropertyList: false,
                showunitList: false,
                showunitTypeList: false,
                showsourceList: false,
                showunitNameList: false,
                showstatusList: false,
                showAmenitiesList: false,
                showtagList: false,
                items: [],
                isHostModeObj: null,
                viewFilterMetadata: {
                    "-1": [1, 3, 4, 5, 6, 7, 8, 10, 11],
                    "-2": [6],
                    "-3": [1, 3, 5],
                    "-4": [6],
                    "-5": [1, 3, 5, 8, 10],
                    "-6": [1, 3, 5, 6, 7, 8, 11]
                },
                options: {
                    scrollbars: true,
                    interactiveScrollbars: true,
                    probeType: 3,
                    mouseWheel: true,
                    mouseWheelSpeed: 1
                },

                variable: false,
                totalLength: null,
                pullDownTextObj: {
                    trigger: 'Loading...',
                    begin: 'Loading...',
                    complete: 'There are no items',
                    error: 'There is server error',
                    refresh: 'Loading...'
                },
                Tagdisable: true,
                checkinbutton: true,
                checkOutbutton: true,
                statusbutton: true,
                Amountlabel: true,
                unassignbutton: true,
                showicon: true,
                entitlements: {},
                linearProgress: false,
                reservationList: [],
                currResObj: {},
                isSummaryLoading: true,
                isDateBeforeOrAfterSixMonths: false,
                loading: true,
                isGreyOut: false,
                isSummaryLoading: false,
                scrllCount: 50,
                scrlBtns: false,
                propertyList: [],
                unitClassList: [],
                unitTypeList: [],
                sourceList: [],
                tagsList: [],
                unitList: [],
                statusList: [],
                amenitiesList: [],
                notesDetailById: {
                    noteId: -1,
                },
                viewList: [
                    { Label: 'All Reservations', ViewListId: -1, IsChecked: 0, isSortLoading: false },
                    { Label: 'Currently In House', ViewListId: -2, IsChecked: 0, isSortLoading: false },
                    { Label: 'Arriving Today', ViewListId: -3, IsChecked: 0, isSortLoading: false },
                    { Label: 'Departing Today', ViewListId: -4, IsChecked: 0, isSortLoading: false },
                    { Label: 'Upcoming Reservations', ViewListId: -5, IsChecked: 1, isSortLoading: false },
                    { Label: 'Today’s Reservations', ViewListId: -6, IsChecked: 0, isSortLoading: false },
                ],
                listType: "list",
                RowsPerPage: 10,
                totalCount: 0,
                viewSaveObject: {
                    viewId: -1,
                    name: null,
                    isPublic: false,
                    entityId: 4,
                    propertyId: -99,
                    UnitClassId: -99,
                    resSourceId: -99,
                    sortColumn: null,
                    sortOrder: null,
                    filters: [],
                    tags: [],
                    columns: [],
                    properties: [],
                    UnitClasses: [],
                    UnitTypes: [],
                    sources: [],
                    units: [],
                    unitList: [],
                    statusList: [],
                    amenitiesList: [],
                    rateplanList: [],
                    startdate: null,
                    stayStartDate:null,
                    stayEndDate:null
                },
                viewAttrsChanged: false,
                viewObjectChanged: false,
                isModalVisible: false,
                today: moment().format("MMM DD YYYY"),
                filterObj: {
                    PropertyId: -99,
                    UnitClassId: -99,
                    ViewListId: -5,
                    SortBy: null,
                    SortOrder: null,
                    resSourceId: -99,
                    TagsList: [],
                    SearchText: [],
                    Properties: [],
                    UnitClasses: [],
                    UnitTypes: [],
                    Sources: [],
                    Units: [],
                    unitList: [],
                    StatusList: [],
                    AmenitiesList: [],
                    Columns: [],
                    rateplanList: [],
                    PageNumber: 1,
                    ItemsPerPage: 20,
                    resid: null,
                    userDate: moment().format("YYYY-MM-DD"),
                    showUnAllocatedReservations: false,
                    includeObsoleteInventory: false,
                    startdate: null,
                    Beds: null,
                    Bedrooms: null,
                    Bathrooms: null,
                    stayStartDate:null,
                    stayEndDate:null
                },
                clearTags: false,
                customViewList: [],
                selectedViewObj: null,
                // toggleFilterPanel: false,
                selectedFilterColumn: null,
                filterSearchTagText: null,
                filterSearchPropertyText: null,
                filterSearchUnitClassText: null,
                filterSearchRateplan: null,
                filterSearchUnitTypeText: null,
                filterSearchSourceTypeText: null,
                filterSearchUnitNameText: null,
                filterSearchUnitList: null,
                filterSearchStatusText: null,
                filterSearchAmenitiesText: null,
                reservationSummaryInfo: {},
                previousReservationSummaryInfo: {},
                Reservation_Status: {},
                folioSummaryDetail: {},
                clearfilterForsearchText: false,
                folioCharges: {},
                notificationAmount: null,
                filterColumnList: {
                    ConfirmationNumber: { Label: "Confirmation Number", ColumnName: "ConfirmationNumber", Type: "text" },
                    // ExternalConfirmationNumber: { Label: "External Confirmation Number", ColumnName: "SourceConfirmationNumber", Type: "text" },
                    Email: { Label: "Email", ColumnName: "Email", Type: "text" },
                    PhoneNumber: { Label: "Phone Number", ColumnName: "PhoneNumber", Type: "text" },
                    GuestName: { Label: "Guest Name", ColumnName: "GuestName", Type: "text" },
                    // GuestLastName: { Label: "Last Name", ColumnName: "GuestLastName", Type: "text" },
                    CheckinDates: { Label: "Check-In/Out Date(s)", ColumnName: "Check-inDates", Type: "date" },
                    // StayDate: { Label: "Stay Date(s)", ColumnName: "StayDate", Type: "date" },
                    BookedDate: { Label: "Booked Date(s)", ColumnName: "DateBooked", Type: "date" },
                    BookedBy: { Label: "Booked By", ColumnName: "BookedBy", Type: "text" },
                    // Beds: { Label: "Beds", ColumnName: "Beds", Type: "number" },
                    // BedRooms: { Label: "Bedrooms", ColumnName: "BedRooms", Type: "number" },
                    // BathRooms: { Label: "Bathrooms", ColumnName: "BathRooms", Type: "number" },
                },
                selectedReservation: null,
                resDetail: null,
                isModalVisibleVal: false,
                modalParams: null,
                rateplanList: [],
                showrateplanList: false,

                opens: null,
                minDate: null,
                maxDate: null,
                singleDatePicker: null,
                timePicker: null,
                timePicker24Hour: null,
                showWeekNumbers: null,
                showDropdowns: null,
                autoApply: null,
                linkedCalendars: null,
                dateFormat: 'DD MMM YYYY',
                stayDateRange: { startDate: null, endDate: null }, 
                filterColumnsDateRange: { startDate: null, endDate: null },
                filterColumnsDateRange2: { startDate: null, endDate: null },
            };
        },
        methods: {
            deleteSelectedFromFilter(filterType) {
                let vm = this;
                if (filterType != "stayDates" && filterType != "Beds" && filterType != "Bedrooms" && filterType != "Bathrooms" && filterType != "showUnAllocatedReservations") {
                    vm.filterObj[filterType].splice(0);
                } else if (filterType == "showUnAllocatedReservations") {
                    vm.filterObj[filterType] = false
                } else if (filterType == "stayDates") {
                    vm.filterObj["stayStartDate"] = null;
                    vm.filterObj["stayEndDate"] = null;
                } else {
                    vm.filterObj[filterType] = null
                }
                vm.applyFilter()
            },
            deleteSelectedColumnFromFilter(column) {
                let vm = this;
                vm.filterObj.Columns = vm.filterObj.Columns.filter(col => col.colunmName != column.colunmName)
                vm.applyFilter()
            },
            folioRecalculateCloseModal() {
                this.isModalVisibleVal = false;
            },

            GetUserEntitlementsAndDefaultProperty() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetUserEntitlementsAndDefaultProperty",
                    params: {
                        ModuleAction: "GetUserEntitlementsAndDefaultProperty"
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            console.log("response in GetUserEntitlementsAndDefaultProperty", response);
                            vm.UserProperties = response.properties;
                            vm.entitlements = response.userEntitlementList;
                            vm.fncIsHousekeepingTaskList();
                            vm.UnassignAndStatus();
                            vm.checkin();
                            vm.tagDisabling();
                            vm.CheckOutbutton();
                            vm.statusButton();
                            vm.AmountLabel();


                            // vm.DefaultProperty = response.defaultPropertyId;
                        }
                    }
                });
            },
            UnassignAndStatus() {
                let vm = this;
                if (vm.entitlements && vm.entitlements.fncHousekeeper.isAssigned === 1) {
                    vm.unassignbutton = true;
                }
                else {
                    vm.unassignbutton = false;
                }
            },
            fncIsHousekeepingTaskList() {
                let vm = this;
                console.log("vm.entitlements.fncHousekeeper.isAssigned", vm.entitlements.fncHousekeeper.isAssigned);
                if (vm.entitlements.fncHousekeeper.isAssigned === 1) {
                    vm.showicon = false;

                }
                else {
                    vm.showicon = true;

                }
            },
            tagDisabling() {
                let vm = this;
                if (vm.entitlements.fncReservationUpdate.isAssigned === -1) {
                    vm.Tagdisable = false;
                }
                else {
                    vm.Tagdisable = true;
                }
            },


            checkin() {
                let vm = this;
                // console.log("vm.entitlements.fncReservationUpdate.isAssigned", vm.entitlements.fncReservationUpdate.isAssigned);
                if (vm.entitlements.fncReservationUpdate.isAssigned === 1 || vm.entitlements.fncHousekeeper.isAssigned === 1) {
                    vm.checkinbutton = true;

                }
                else {
                    vm.checkinbutton = false;

                }
            },
            CheckOutbutton() {
                let vm = this;
                //  console.log("fncHousekeepingTaskUpdate+ fncReservationSave+fncReservationUpdate+ fncReservationList",fncHousekeepingTaskUpdate);
                if (vm.entitlements.fncReservationUpdate.isAssigned === 1 || vm.entitlements.fncHousekeeper.isAssigned === 1) {
                    vm.checkOutbutton = true;
                }
                else {
                    vm.checkOutbutton = false;
                }
            },
            statusButton() {
                let vm = this;
                if (vm.entitlements.fncReservationUpdate.isAssigned === 1 || vm.entitlements.fncHousekeeper.isAssigned === 1) {
                    vm.statusbutton = true;
                }
                else {
                    vm.statusbutton = false;
                }
            },

            AmountLabel() {
                let vm = this;
                if (vm.entitlements && vm.entitlements.fncFolioView.isAssigned === -1) {
                    vm.Amountlabel = false;
                }
                else {
                    vm.Amountlabel = true;


                }

            },


            formatStartYear(date) {
                let scope = this;
                let diff = moment(date).diff(
                    scope.today,
                    "months"
                );
                // if (Math.abs(diff) >= 6) {
                return moment(date, "YYYY-MM-DD").format("YYYY");
                // }
                // else {
                //   return null;
                // }
            },
            formatStartDate(date) {
                return moment(date, "YYYY-MM-DD").format("MMM DD");
            },
            formatEndDate(date) {
                return moment(date, "YYYY-MM-DD").format("MMM DD");
            },

            formatDateBooked(date) {
                let vm = this;
                let diff = moment(date).diff(vm.today, 'months');
                // if (Math.abs(diff) >= 6) {
                return moment(date, "YYYY-MM-DD").format("DD MMM ");
                // }
                // else {
                //   return moment(date, "YYYY-MM-DD").format("DD MMM");
                // }

            },
            formatYear(date) {
                let vm = this;
                let diff = moment(date).diff(vm.today, 'months');
                return moment(date, "YYYY-MM-DD").format("YYYY");
            },


            applyFilter() {
                let vm = this;
                vm.items = [];
                vm.filterObj.PageNumber = 1;
                // vm.toggleFilterPanel = false;
                vm.showPropertyList = false,
                    vm.showunitList = false,
                    vm.showunitTypeList = false,
                    vm.showsourceList = false,
                    vm.showunitNameList = false,
                    vm.showstatusList = false,
                    vm.showAmenitiesList = false,
                    vm.showtagList = false,
                    vm.viewSaveObject.propertyId = vm.filterObj.PropertyId;
                vm.viewSaveObject.UnitClassId = vm.filterObj.UnitClassId;
                vm.viewSaveObject.resSourceId = vm.filterObj.resSourceId;
                vm.viewSaveObject.tags.splice(0, vm.viewSaveObject.tags.length, ...vm.filterObj.TagsList);
                vm.viewSaveObject.properties.splice(0, vm.viewSaveObject.properties.length, ...vm.filterObj.Properties);
                vm.viewSaveObject.UnitTypes.splice(0, vm.viewSaveObject.UnitTypes.length, ...vm.filterObj.UnitTypes);
                vm.viewSaveObject.rateplanList.splice(0, vm.viewSaveObject.rateplanList.length, ...vm.filterObj.rateplanList);
                vm.viewSaveObject.UnitClasses.splice(0, vm.viewSaveObject.UnitClasses.length, ...vm.filterObj.UnitClasses);
                vm.viewSaveObject.sources.splice(0, vm.viewSaveObject.sources.length, ...vm.filterObj.Sources);
                vm.viewSaveObject.unitList.splice(0, vm.viewSaveObject.unitList.length, ...vm.filterObj.unitList);
                vm.viewSaveObject.statusList.splice(0, vm.viewSaveObject.statusList.length, ...vm.filterObj.StatusList);
                vm.viewSaveObject.amenitiesList.splice(0, vm.viewSaveObject.amenitiesList.length, ...vm.filterObj.AmenitiesList);
                for (let col of vm.filterObj.Columns) {
                    if (col.colunmName != "StayDate" && col.colunmName != "DateBooked" && col.colunmName != "Check-inDates") {
                        col.value = null
                    }
                }

                vm.viewSaveObject.columns = {};
                vm.viewSaveObject.columns = JSON.parse(JSON.stringify(vm.filterObj.Columns));

                // vm.viewSaveObject.columns.splice(0, vm.viewSaveObject.columns.length, ...vm.filterObj.Columns);
                if (vm.filterObj.Beds || vm.filterObj.Bedrooms || vm.filterObj.Bathrooms || vm.viewSaveObject.tags.length > 1 || vm.viewSaveObject.properties.length > 1 || vm.viewSaveObject.UnitClasses.length > 1 || vm.viewSaveObject.sources.length > 1 || vm.viewSaveObject.unitList.length > 1 || vm.viewSaveObject.statusList.length > 1 || vm.viewSaveObject.amenitiesList.length > 1 || vm.filterObj.SearchText.length > 1) {
                    vm.viewAttrsChanged = true;
                }
                else if (((vm.viewSaveObject.tags.length == 1) && (vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.UnitTypes.length || vm.viewSaveObject.rateplanList.length || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.unitList.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.filterObj.SearchText.length == 1)) ||
                    ((vm.viewSaveObject.properties.length == 1) && (vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.UnitTypes.length || vm.viewSaveObject.rateplanList.length || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.unitList.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.filterObj.SearchText.length == 1)) ||
                    ((vm.viewSaveObject.UnitClasses.length == 1) && (vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitTypes.length || vm.viewSaveObject.rateplanList.length || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.unitList.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.filterObj.SearchText.length == 1)) ||
                    ((vm.viewSaveObject.sources.length == 1) && (vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.UnitTypes.length || vm.viewSaveObject.rateplanList.length || vm.viewSaveObject.unitList.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.filterObj.SearchText.length == 1)) ||
                    ((vm.viewSaveObject.unitList.length == 1) && (vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.UnitTypes.length || vm.viewSaveObject.rateplanList.length || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.filterObj.SearchText.length == 1)) ||
                    ((vm.viewSaveObject.UnitTypes.length == 1) && (vm.viewSaveObject.rateplanList.length == 1) && (vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.viewSaveObject.unitList.length == 1 || vm.filterObj.SearchText.length == 1)) ||
                    ((vm.viewSaveObject.statusList.length == 1) && (vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.UnitTypes.length || vm.viewSaveObject.rateplanList.length || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.unitList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.filterObj.SearchText.length == 1)) ||
                    ((vm.viewSaveObject.amenitiesList.length == 1) && (vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.UnitTypes.length || vm.viewSaveObject.rateplanList.length || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.unitList.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.filterObj.SearchText.length == 1))) {
                    vm.viewAttrsChanged = true;
                }
                else {
                    vm.viewAttrsChanged = false;
                }
                if (vm.viewSaveObject.columns.length >= 1) {
                    let result = vm.viewSaveObject.columns.filter(col => (col.value != null || col.rangeVal != null));

                    let result2 = vm.viewSaveObject.columns.filter(col => col.arrText.length > 0);
                    vm.filterObj.Columns = result.concat(result2);

                    console.log("result", result)
                    console.log("result2", result2)
                    if (result.length > 1 || (result.length == 0 && result2.length > 1) || (result2.length > 0 && result.length == 1)) {
                        vm.viewAttrsChanged = true;
                    }
                    for (var column = 0; vm.viewSaveObject.columns.length > column; column++) {

                        if (vm.viewSaveObject.columns[column]["arrText"].length > 1) {
                            vm.viewAttrsChanged = true;
                        }
                        else if (((vm.viewSaveObject.columns[column]["arrText"].length == 1) || (vm.viewSaveObject.columns[column]["arrText"].length == 0 && vm.viewSaveObject.columns[column].value != null)) && (vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.unitList.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.filterObj.SearchText.length == 1)) {
                            vm.viewAttrsChanged = true;
                        }

                        else if (vm.viewSaveObject.columns[column]["arrText"].length == 0 && vm.viewSaveObject.columns[column].value == null) {

                        }
                    }

                }
                vm.viewObjectChanged = true;
                this.parentCallback({ toggleFilterPanel: false, viewSaveObject: this.viewSaveObject, filterObj: this.filterObj, clearFilter: false, fromfile: "filterpanel", viewAttrsChanged: this.viewAttrsChanged })

            },
            reservationsView(viewObj) {
                let vm = this;
                vm.items = [];

                vm.filterObj.PageNumber = 1;

                vm.filterObj.ViewListId = viewObj.ViewId ? viewObj.ViewId : viewObj.ViewListId;
                if (viewObj.ViewListId) {
                    for (var i in vm.viewList) {
                        if (vm.filterObj.ViewListId == vm.viewList[i].ViewListId) {
                            vm.isGreyOut = true;
                            vm.viewList[i].isSortLoading = true;
                        }
                    }
                }
                else if (viewObj.ViewId) {
                    for (var i in vm.customViewList) {
                        if (vm.filterObj.ViewListId == vm.customViewList[i].ViewId) {
                            vm.isGreyOut = true;
                            vm.customViewList[i].isSortLoading = true;
                        }
                    }
                }
                vm.selectedViewObj = viewObj;
            },


            scrollRight: function () {
                var container = this.$el.querySelector("#tagScrollSection");
                var cnt = this.scrllCount++;
                container.scrollLeft = cnt;
                console.log("scroll counter before" + cnt);
                this.scrllCount = this.scrllCount + 50;
                console.log("scroll counter after" + cnt);
                this.scrollLeft = cnt;


            },
            scrollLeft: function () {

                var container = this.$el.querySelector(".scrollingTags");
                console.log("Inner width -" + container.clientWidth);
                if (this.scrllCount == -1) {
                    var container = this.$el.querySelector("#tagScrollSection");
                    container.scrollLeft = 0;
                    console.log("If");
                } else {
                    var container = this.$el.querySelector("#tagScrollSection");
                    var cnt2 = this.scrllCount--;
                    container.scrollLeft = cnt2;
                    console.log("scroll counter before" + cnt2);
                    this.scrllCount = this.scrllCount - 50;
                    console.log("scroll counter after" + cnt2);
                }
            },

            switchView() {
                if (this.listType === "list") {
                    this.listType = "card";
                } else {
                    this.listType = "list";
                }
            },

            getPropertyMetaData: function () {
                let scope = this;
                console.log("scope.propertyId", scope.propertyId)
                this.$store.dispatch("dataRequestHandler", {
                    key: "GetPropertyMetaData",
                    params: {
                        ModuleAction: "GetPropertyMetaData",
                        PropertyId: scope.propertyId
                    },
                    callback: function (err, response) {
                        if (response) {
                            console.log("response in getPropertyMetaData", response)
                            scope.propertyList = response.recordsets[0];
                            scope.unitClassList = response.recordsets[1];
                            scope.sourceList = response.recordsets[2];
                        } else {
                            console.log(err);
                        }
                    }
                });
            },

            saveView() {
                let vm = this;
                Object.keys(vm.headerColumnList).forEach(function (key) {
                    if (vm.headerColumnList[key]["IsChecked"]) {
                        vm.viewSaveObject.columns.push(vm.headerColumnList[key]);
                    }
                })
                vm.isModalVisible = true;
            },
            updateView() {
                let vm = this;
                Object.keys(vm.headerColumnList).forEach(function (key) {
                    if (vm.headerColumnList[key]["IsChecked"]) {
                        vm.viewSaveObject.columns.push(vm.headerColumnList[key]);
                    }
                })
                vm.viewSaveObject.isUpdate = true;
                vm.viewSaveObject.propertyId = vm.filterObj.PropertyId;
                vm.viewSaveObject.UnitClassId = vm.filterObj.UnitClassId;
                vm.viewSaveObject.resSourceId = vm.filterObj.resSourceId;
                vm.viewSaveObject.viewId = vm.selectedViewObj.ViewId;
                vm.viewSaveObject.name = vm.selectedViewObj.ViewName;
                vm.viewSaveObject.tags.splice(0, vm.viewSaveObject.tags.length, ...vm.filterObj.TagsList);
                vm.isModalVisible = true;
            },
            saveasView() {
                let vm = this;
                Object.keys(vm.headerColumnList).forEach(function (key) {
                    if (vm.headerColumnList[key]["IsChecked"]) {
                        vm.viewSaveObject.columns.push(vm.headerColumnList[key]);
                    }
                })
                vm.viewSaveObject.isSaveAs = true;
                vm.viewSaveObject.propertyId = vm.filterObj.PropertyId;
                vm.viewSaveObject.UnitClassId = vm.filterObj.UnitClassId;
                vm.viewSaveObject.resSourceId = vm.filterObj.resSourceId;
                vm.viewSaveObject.viewId = vm.selectedViewObj.ViewId;
                vm.viewSaveObject.name = vm.selectedViewObj.ViewName;
                vm.viewSaveObject.tags.splice(0, vm.viewSaveObject.tags.length, ...vm.filterObj.TagsList);
                vm.isModalVisible = true;
            },
            closeModal() {
                this.viewSaveObject = {
                    viewId: -1,
                    name: null,
                    isPublic: false,
                    entityId: 4,
                    propertyId: -99,
                    UnitClassId: -99,
                    resSourceId: -99,
                    sortColumn: null,
                    sortOrder: null,
                    filters: [],
                    tags: [],
                    columns: [],
                    startdate: null
                };
                this.isModalVisible = false;
                this.viewAttrsChanged = false;
                this.clearTags = true;
            },
            addTagToFilters(tagObj) {
                if (tagObj)
                    this.filterObj.TagsList.push(tagObj);
            },
            deleteTagFromFilters(tagObj) {
                if (tagObj) {
                    let index = this.filterObj.TagsList.findIndex((tag) => {
                        return tag.TagId === tagObj.TagId;
                    })
                    if (index > -1) {
                        this.filterObj.TagsList.splice(index, 1);
                    }
                }
            },
            selectColumn(column, event) {
                let vm = this;
                vm.$store.state.bus.$emit("headerIsChecked", column);
                let isAnyColumnUnchecked = false;
                Object.keys(vm.headerColumnList).forEach(function (key) {
                    if (!vm.headerColumnList[key]["IsChecked"] || !event.currentTarget.checked) {
                        isAnyColumnUnchecked = true;
                    }
                })
            },

            getReservationCustomViews() {
                let scope = this;
                this.$store.dispatch("dataRequestHandler", {
                    key: "GetEntityCustomViewList",
                    params: {
                        EntityId: 4
                    },
                    callback: function (err, response) {
                        if (response) {
                            scope.customViewList = response.customViewList;
                        } else {
                            console.log(err);
                        }
                    }
                });
            },
            viewSaveCallback() {
                this.getReservationCustomViews();
            },
            addPropertyToFilter(propertyObj) {
                let vm = this;
                vm.filterObj.Properties.push(propertyObj);
                vm.filterSearchPropertyText = null;
                var index = vm.propertyList.indexOf(propertyObj);
                if (index > -1) {
                    vm.propertyList.splice(index, 1);
                }
                vm.filterObj.Properties = vm.filterObj.Properties.sort((a, b) => a.PropertyName.localeCompare(b.PropertyName))
                vm.GetUnitClasssListBySearchText();
                // vm.GetUnitTypeListBySearchText();
                vm.selectedFilterColumn = null;
            },
            showpropertyFnc() {
                this.showPropertyList = true;
            },
            showUnitClassFnc() {
                this.showunitList = true;
            },
            showrateplanFnc() {
                this.showrateplanList = true
            },
            showUnitTypeFnc() {
                this.showunitTypeList = true;
            },

            showsourceFnc() {
                this.showsourceList = true;
            },
            showunitNameFnc() {
                this.showunitNameList = true;
                console.log("this.showunitNameList", this.showunitNameList)
            },
            showstatusFnc() {
                this.showstatusList = true;
            },
            showAmenitiesFnc() {
                this.showAmenitiesList = true;
            },
            showtagFnc() {
                this.showtagList = true;
            },



            removePropertyFromFilter(propertyObj, event) {
                let vm = this;
                var index = vm.filterObj.Properties.indexOf(propertyObj);
                if (index > -1) {
                    vm.filterObj.Properties.splice(index, 1);
                }
                vm.propertyList.push(propertyObj);
                vm.propertyList = vm.propertyList.sort((a, b) => a.PropertyName.localeCompare(b.PropertyName))
                if (event)
                    event.stopPropagation();
            },
            addUnitClassToFilter(UnitClassObj) {
                let vm = this;
                vm.filterObj.UnitClasses.push(UnitClassObj);
                vm.filterSearchUnitClassText = null;
                var index = vm.unitClassList.indexOf(UnitClassObj);
                console.log("index of Amenities=>", index, UnitClassObj);
                vm.filterObj.UnitClasses = vm.filterObj.UnitClasses.sort((a, b) => a.UnitClassName.localeCompare(b.UnitClassName)) 
                if (index > -1) {
                    vm.unitClassList.splice(index, 1);
                    console.log("index", index)
                    console.log("vm.unitClassList", vm.unitClassList)
                }
                vm.selectedFilterColumn = null;
            },
            addrateplanToFilter(ratePlanObj) {
                let vm = this;
                vm.filterObj.rateplanList.push(ratePlanObj);
                vm.filterSearchRateplan = null;
                var index = vm.rateplanList.indexOf(ratePlanObj);
                console.log("index of ratePlan=>", index, ratePlanObj);
                if (index > -1) {
                    vm.rateplanList.splice(index, 1);
                    console.log("index", index)
                    console.log("vm.rateplanList", vm.rateplanList)
                }
                vm.selectedFilterColumn = null;
            },
            removeUnitClassFromFilter(UnitClassObj, event) {
                let vm = this;
                var index = vm.filterObj.UnitClasses.indexOf(UnitClassObj);
                if (index > -1) {
                    vm.filterObj.UnitClasses.splice(index, 1);
                }
                vm.unitClassList.push(UnitClassObj);
                vm.unitClassList = vm.unitClassList.sort((a, b) => a.UnitClassName.localeCompare(b.UnitClassName)) 
                if (event)
                    event.stopPropagation();
            },
            removeRateplanFromFilter(ratePlanObj, event) {
                let vm = this;
                var index = vm.filterObj.rateplanList.indexOf(ratePlanObj);
                if (index > -1) {
                    vm.filterObj.rateplanList.splice(index, 1);
                }
                vm.rateplanList.push(ratePlanObj);
                if (event)
                    event.stopPropagation();
            },
            addUnitTypeToFilter(UnitTypeObj) {
                console.log("UnitTypeObj", UnitTypeObj);
                let vm = this;
                vm.filterObj.UnitTypes.push(UnitTypeObj);
                vm.filterSearchUnitTypeText = null;
                var index = vm.unitTypeList.indexOf(UnitTypeObj);
                console.log("index of Amenities=>", index, UnitTypeObj);
                vm.filterObj.UnitTypes = vm.filterObj.UnitTypes.sort((a, b) => a.UnitTypeName.localeCompare(b.UnitTypeName))
                if (index > -1) {
                    vm.unitTypeList.splice(index, 1);
                    console.log("index", index)
                    // console.log("vm.unitClassList", vm.unitClassList)
                }
                vm.selectedFilterColumn = null;
            },
            removeUnitTypeFromFilter(UnitTypeObj, event) {
                let vm = this;
                var index = vm.filterObj.UnitTypes.indexOf(UnitTypeObj);
                if (index > -1) {
                    vm.filterObj.UnitTypes.splice(index, 1);
                }
                vm.unitTypeList.push(UnitTypeObj);
                vm.unitTypeList = vm.unitTypeList.sort((a, b) => a.UnitTypeName.localeCompare(b.UnitTypeName))
                if (event)
                    event.stopPropagation();
            },
            addSourceToFilter(sourceObj) {
                let vm = this;
                vm.filterObj.Sources.push(sourceObj);
                vm.filterSearchSourceTypeText = null;
                var index = vm.sourceList.indexOf(sourceObj);
                vm.filterObj.Sources = vm.filterObj.Sources.sort((a, b) => a.sourceName.localeCompare(b.sourceName))
                console.log("index of Amenities=>", index, sourceObj);
                if (index > -1) {
                    vm.sourceList.splice(index, 1);
                    console.log("index", index)
                    console.log("vm.unitClassList", vm.sourceList)
                }
                vm.selectedFilterColumn = null;
            },
            removeSourceFromFilter(sourceObj, event) {
                let vm = this;
                var index = vm.filterObj.Sources.indexOf(sourceObj);
                if (index > -1) {
                    vm.filterObj.Sources.splice(index, 1);
                }
                vm.sourceList.push(sourceObj);
                vm.sourceList = vm.sourceList.sort((a, b) => a.sourceName.localeCompare(b.sourceName))
                if (event)
                    event.stopPropagation();
            },
            addUnitToFilter(unitObj) {
                let vm = this;
                vm.filterObj.unitList.push(unitObj);
                vm.filterSearchUnitList = null;
                var index = vm.unitList.indexOf(unitObj);
                vm.filterObj.unitList = vm.filterObj.unitList.sort((a, b) => a.UnitName.localeCompare(b.UnitName))
                if (index > -1) {
                    vm.unitList.splice(index, 1);
                }
                vm.selectedFilterColumn = null;
            },
            addStatusToFilter(statusObj) {
                let vm = this;
                vm.filterObj.StatusList.push(statusObj);
                vm.filterSearchStatusText = null;
                var index = vm.statusList.indexOf(statusObj);
                vm.filterObj.StatusList = vm.filterObj.StatusList.sort((a, b) => a.StatusName.localeCompare(b.StatusName))
                if (index > -1) {
                    vm.statusList.splice(index, 1);
                }
                vm.selectedFilterColumn = null;
            },
            addAmenitiesToFilter(amenitiesObj) {
                let vm = this;
                vm.filterObj.AmenitiesList.push(amenitiesObj);
                vm.filterSearchAmenitiesText = null;
                var index = vm.amenitiesList.indexOf(amenitiesObj);
                vm.filterObj.AmenitiesList = vm.filterObj.AmenitiesList.sort((a, b) => a.listname.localeCompare(b.listname)) 
                if (index > -1) {
                    vm.amenitiesList.splice(index, 1);
                }
                vm.selectedFilterColumn = null;
            },
            removeUnitFromFilter(unitObj, event) {
                let vm = this;
                var index = vm.filterObj.unitList.indexOf(unitObj);
                if (index > -1) {
                    vm.filterObj.unitList.splice(index, 1);
                }
                vm.unitList.push(unitObj);
                vm.unitList = vm.unitList.sort((a, b) => a.UnitName.localeCompare(b.UnitName))
                if (event)
                    event.stopPropagation();
            },
            removeAmenitiesFromFilter(amenitiesObj, event) {
                let vm = this;
                var index = vm.filterObj.AmenitiesList.indexOf(amenitiesObj);
                if (index > -1) {
                    vm.filterObj.AmenitiesList.splice(index, 1);
                }
                vm.amenitiesList.push(amenitiesObj);
                vm.amenitiesList = vm.amenitiesList.sort((a, b) => a.listname.localeCompare(b.listname)) 
                if (event)
                    event.stopPropagation();
            },
            removeStatusFromFilter(statusObj, event) {
                let vm = this;
                var index = vm.filterObj.StatusList.indexOf(statusObj);
                if (index > -1) {
                    vm.filterObj.StatusList.splice(index, 1);
                }
                vm.statusList.push(statusObj);
                vm.statusList = vm.statusList.sort((a, b) => a.StatusName.localeCompare(b.StatusName))
                if (event)
                    event.stopPropagation();
            },
            getClientTags(searchText) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetClientTagsBySearchText",
                        params: {
                            searchText: searchText
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                // vm.tagsList.splice(0, vm.tagsList.length, ...response[0]);

                                let List = response[0];
                                for (var i = 0; i < vm.filterObj.TagsList.length; i++) {
                                    console.log("vm.filterObj.TagsList[i].TagId", vm.filterObj.TagsList[i].TagId)
                                    let index = List.findIndex(x => x.TagId == vm.filterObj.TagsList[i].TagId);
                                    if (index > -1)
                                        List.splice(index, 1);
                                    console.log("index", index);
                                }

                                vm.tagsList.splice(0, vm.tagsList.length, ...List);
                            }
                            if (vm.tagsList.length)
                                vm.showTagInFilter = true;
                        }
                    });
            },
            addTagToFilter(tagObj) {
                let vm = this;
                vm.filterObj.TagsList.push(tagObj);
                vm.showTagInFilter = false;
                vm.filterSearchTagText = null;
                var index = vm.tagsList.indexOf(tagObj);
                console.log("index of Amenities=>", index, tagObj);
                vm.filterObj.TagsList = vm.filterObj.TagsList.sort((a, b) => a.TagName.localeCompare(b.TagName))
                if (index > -1) {
                    vm.tagsList.splice(index, 1);
                    console.log("index", index)
                    console.log("vm.unitClassList", vm.tagsList)
                }
                vm.selectedFilterColumn = null;
            },
            removeTagFromFilter(tagObj, event) {
                let vm = this;
                var index = vm.filterObj.TagsList.indexOf(tagObj);
                if (index > -1) {
                    vm.filterObj.TagsList.splice(index, 1);
                }
                vm.tagsList.push(tagObj);
                vm.tagsList = vm.tagsList.sort((a, b) => a.TagName.localeCompare(b.TagName))
                if (event)
                    event.stopPropagation();
            },
            showFilterByType(filterCol) {
                let vm = this;
                setTimeout(function () {
                    vm.selectedFilterColumn = filterCol;
                    if (filterCol == "property") {
                        vm.getPropertiesBySearchText();
                        // }
                        $("#propertyDropDown").show();
                        // setTimeout(function () {

                        //   $("#propertyDropDown").show();
                        // }, 10);
                    }
                    else if (filterCol == "UnitClass") {
                        vm.GetUnitClasssListBySearchText();
                        $("#UnitClassDropDown").show();
                        // setTimeout(function () {

                        //   $("#UnitClassDropDown").show();
                        // }, 10);
                    }
                    else if (filterCol == "rateplan") {
                        vm.getRatePlanDetailList();
                        $("#rateplanDropDown").show();
                        // setTimeout(function () {

                        //   $("#UnitClassDropDown").show();
                        // }, 10);
                    }
                    else if (filterCol == "unitList") {
                        vm.getUnitNamesBySearchText();
                        $("#unitListDropDown").show();
                        // setTimeout(function () {

                        //   $("#UnitClassDropDown").show();
                        // }, 10);
                    }
                    else if (filterCol == "UnitType") {
                        vm.GetUnitTypeListBySearchText();
                        $("#UnitTypeDropDown").show();
                        // setTimeout(function () {

                        //   $("#UnitClassDropDown").show();
                        // }, 10);
                    }
                    else if (filterCol == "source") {
                        vm.getSourceListBySearchText();
                        $("#sourceDropDown").show();
                        // setTimeout(function () {

                        //   $("#sourceDropDown").show();
                        // }, 10);

                    }
                    else if (filterCol == "tag") {
                        vm.getClientTags();
                        $("#tagDropDown").show();
                        // setTimeout(function () {

                        //   $("#tagDropDown").show();
                        // }, 10);
                    }
                    else if (filterCol == "unitName") {
                        vm.getUnitNamesBySearchText();
                        $("#unitNameDropDown").hide();
                        $("#unitNameDropDown").show();
                        // setTimeout(function () {

                        //   $("#unitNameDropDown").show();
                        // }, 10);

                    }
                    else if (filterCol == "status") {
                        vm.getStatusBySearchText();
                        $("#statusDropDown").show();
                        // setTimeout(function () {

                        //   $("#statusDropDown").show();
                        // }, 10);

                    }
                    else if (filterCol == "amenities") {
                        vm.getAmenetiesByClient();
                        $("#amenitiesDropDown").show();
                    }
                }, 10);
            },
            getRatePlanDetailList(SearchText) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetRateplanList_bysearch",
                    params: {
                        StatusId: 1,
                        SearchText: SearchText,
                        Tagtext: null,
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Get_RatePlanList==>", err);
                            return;
                        }
                        if (response) {
                            console.log("Get_RatePlanList==>", response);
                            // vm.ratePlanList = response[1];
                            let List = response[1];
                            // console.log("List============>",List);
                            for (var i = 0; i < vm.filterObj.rateplanList.length; i++) {
                                console.log("vm.filterObj.UnitTypes[i].UnitTypeId", vm.filterObj.rateplanList[i].RatePlanId)
                                let index = List.findIndex(x => x.RatePlanId == vm.filterObj.rateplanList[i].RatePlanId);
                                if (index > -1)
                                    List.splice(index, 1);
                                console.log("index", index);
                            }

                            vm.rateplanList.splice(0, vm.rateplanList.length, ...List);

                        }
                    }
                });
            },
            closeAllSuggestions(evt) {
            },
            getAmenetiesByClient(searchText) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "getAmenetiesByClient",
                    params: {
                        ModuleAction: "getAmenetiesByClient",
                        SearchText: searchText
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            let amenitiesListObj = response.recordsets[0];
                            console.log("response in getAmenetiesByClient", amenitiesListObj);
                            let amenityList = [{ id: 1, name: 'x' }, { id: 2, name: 'y' }, { id: 3, name: 'z' }]
                            let List = response.recordsets[0];//amenityList;//response.amenitiesList;
                            for (var i = 0; i < vm.filterObj.AmenitiesList.length; i++) {
                                console.log("vm.filterObj.AmenitiesList[i].listid", vm.filterObj.AmenitiesList[i].listid)
                                let index = List.findIndex(x => x.listid == vm.filterObj.AmenitiesList[i].listid);
                                if (index > -1)
                                    List.splice(index, 1);
                                console.log("index", index);
                            }
                            vm.amenitiesList.splice(0, vm.amenitiesList.length, ...List);
                        }
                    }
                });
            },
            getPropertiesBySearchText(searchText) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetPropertiesBySearchText",
                        params: {
                            searchText: searchText
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                console.log("...response.propertyList", response.propertyList)

                                let List = response.propertyList;
                                for (var i = 0; i < vm.filterObj.Properties.length; i++) {
                                    console.log("vm.filterObj.Properties[i].PropertyId", vm.filterObj.Properties[i].PropertyId)
                                    let index = List.findIndex(x => x.PropertyId == vm.filterObj.Properties[i].PropertyId);
                                    if (index > -1)
                                        List.splice(index, 1);
                                    console.log("index", index);
                                }

                                vm.propertyList.splice(0, vm.propertyList.length, ...List);
                            }
                        }
                    });
            },
            GetUnitClasssListBySearchText(searchText) {
                let vm = this;
                let resultObj = vm.filterObj.Properties.map(obj => obj.PropertyId);
                console.log("resultObj", resultObj);
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetUnitClasssListBySearchText",
                        params: {
                            searchText: searchText,
                            PropertyId: resultObj.toString()
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                console.log("response", response);

                                let List = response.unitClassList;
                                for (var i = 0; i < vm.filterObj.UnitClasses.length; i++) {
                                    console.log("vm.filterObj.UnitClasses[i].UnitClassId", vm.filterObj.UnitClasses[i].UnitClassId)
                                    let index = List.findIndex(x => x.UnitClassId == vm.filterObj.UnitClasses[i].UnitClassId);
                                    if (index > -1)
                                        List.splice(index, 1);
                                    console.log("index", index);
                                }

                                vm.unitClassList.splice(0, vm.unitClassList.length, ...List);
                            }
                        }
                    });
            },
            GetUnitTypeListBySearchText(searchText) {
                let vm = this;
                let resultObj = vm.filterObj.Properties.map(obj => obj.PropertyId);
                console.log("resultObj", resultObj);
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetUnitTypeListBySearchText",
                        params: {
                            searchText: searchText,
                            PropertyId: resultObj.toString(),
                            FromSetup: false
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                console.log("unitTypeListunitTypeList", response);

                                let List = response.unitTypeList;
                                // console.log("List============>",List);
                                for (var i = 0; i < vm.filterObj.UnitTypes.length; i++) {
                                    console.log("vm.filterObj.UnitTypes[i].UnitTypeId", vm.filterObj.UnitTypes[i].UnitTypeId)
                                    let index = List.findIndex(x => x.UnitTypeId == vm.filterObj.UnitTypes[i].UnitTypeId);
                                    if (index > -1)
                                        List.splice(index, 1);
                                    console.log("index", index);
                                }

                                vm.unitTypeList.splice(0, vm.unitTypeList.length, ...List);
                            }
                        }
                    });
            },
            getSourceListBySearchText(searchText) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetSourceListBySearchText",
                        params: {
                            searchText: searchText
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                let List = response.sourceList;
                                for (var i = 0; i < vm.filterObj.Sources.length; i++) {
                                    console.log("vm.filterObj.Sources[i].sourceID", vm.filterObj.Sources[i].sourceID)
                                    let index = List.findIndex(x => x.sourceID == vm.filterObj.Sources[i].sourceID);
                                    if (index > -1)
                                        List.splice(index, 1);
                                    console.log("index", index);
                                }

                                vm.sourceList.splice(0, vm.sourceList.length, ...List);
                            }
                        }
                    });
            },
            getUnitNamesBySearchText(searchText) {
                let vm = this;
                let resultObj = vm.filterObj.Properties.map(obj => obj.PropertyId);
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetUnitListBySearchText",
                        params: {
                            searchText: searchText,
                            PropertyId: resultObj.toString()
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                let List = response.unitList;
                                for (var i = 0; i < vm.filterObj.unitList.length; i++) {
                                    console.log("vm.filterObj.unitList[i].UnitId", vm.filterObj.unitList[i].UnitId)
                                    let index = List.findIndex(x => x.UnitId == vm.filterObj.unitList[i].UnitId);
                                    if (index > -1)
                                        List.splice(index, 1);
                                    console.log("index", index);
                                }

                                vm.unitList.splice(0, vm.unitList.length, ...List);
                            }
                        }
                    });
            },
            getStatusBySearchText(searchText) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetResevationStatusListBySearchText",
                        params: {
                            searchText: searchText
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                let List = response.statusList;
                                for (var i = 0; i < vm.filterObj.StatusList.length; i++) {
                                    console.log("vm.filterObj.StatusList[i].StatusId", vm.filterObj.StatusList[i].StatusId)
                                    let index = List.findIndex(x => x.StatusId == vm.filterObj.StatusList[i].StatusId);
                                    if (index > -1)
                                        List.splice(index, 1);
                                    console.log("index", index);
                                }

                                vm.statusList.splice(0, vm.statusList.length, ...List);
                            }
                        }
                    });
            },
            closeFilter(closePanel) {
                let vm = this;
                // vm.toggleFilterPanel = false;

                vm.showPropertyList = false,
                    vm.showunitList = false,
                    vm.showunitTypeList = false
                vm.showsourceList = false,
                    vm.showunitNameList = false,
                    vm.showstatusList = false,
                    vm.showAmenitiesList = false,
                    vm.showtagList = false
                if (vm.filterObj.Columns.length >= 1) {
                    let result = vm.filterObj.Columns.filter(col => col.value != null);

                    let result2 = vm.filterObj.Columns.filter(col => col.arrText.length > 0);
                    vm.filterObj.Columns = result.concat(result2);
                }
                // if(!closePanel){
                this.parentCallback({ closePanel: true, toggleFilterPanel: false, viewSaveObject: this.viewSaveObject, filterObj: this.filterObj, clearFilter: false, fromfile: "filterpanel", viewAttrsChanged: this.viewAttrsChanged })
                // }
            },
            deleteSelectedPropertyFromFilter(index, propObj) {
                this.removePropertyFromFilter(propObj);
                this.viewSaveObject.properties.splice(index, 1);
                this.applyFilter();
            },
            deleteSelectedUnitClassFromFilter(index, UnitClassObj) {
                this.removeUnitClassFromFilter(UnitClassObj);
                this.viewSaveObject.UnitClasses.splice(index, 1);
                this.applyFilter();
            },
            deleteSelectedUnitTypeFromFilter(index, ratePlanObj) {
                this.removeUnitTypeFromFilter(ratePlanObj);
                this.viewSaveObject.UnitTypes.splice(index, 1);
                this.applyFilter();
            },
            deleteSelectedUnitTypeFromFilter(index, UnitTypeObj) {
                this.removeUnitTypeFromFilter(UnitTypeObj);
                this.viewSaveObject.rateplanList.splice(index, 1);
                this.applyFilter();
            },
            deleteSelectedSourceFromFilter(index, sourceObj) {
                this.removeSourceFromFilter(sourceObj);
                this.viewSaveObject.sources.splice(index, 1);
                this.applyFilter();
            },
            deleteUnAllocatedReservations() {
                this.filterObj.showUnAllocatedReservations = false;
                this.applyFilter();
            },
            deleteIncludeObsoleteInventory() {
                this.filterObj.includeObsoleteInventory = false;
                this.applyFilter();
            },
            deleteSearchText(searchTextIndex, searchText) {
                let vm = this;
                vm.filterObj.PageNumber = 1;
                vm.items = [];
                this.filterObj.SearchText.splice(searchTextIndex, 1);
                if (vm.filterObj.SearchText.length > 1) {
                    vm.viewAttrsChanged = true;
                }
                else if (vm.filterObj.SearchText.length == 1 && (vm.viewSaveObject.tags.length > 1 || vm.viewSaveObject.properties.length > 1 || vm.viewSaveObject.UnitTypes.length > 1 || vm.viewSaveObject.rateplanList.length > 1 || vm.viewSaveObject.UnitClasses.length > 1 || vm.viewSaveObject.sources.length > 1 || vm.viewSaveObject.unitList.length > 1 || vm.viewSaveObject.statusList.length > 1 || vm.viewSaveObject.amenitiesList.length > 1 || vm.filterObj.SearchText.length > 1 || vm.viewSaveObject.tags.length == 1 || vm.viewSaveObject.properties.length == 1 || vm.viewSaveObject.UnitTypes.length == 1 || vm.viewSaveObject.rateplanList.length == 1 || vm.viewSaveObject.UnitClasses.length == 1 || vm.viewSaveObject.sources.length == 1 || vm.viewSaveObject.unitList.length == 1 || vm.viewSaveObject.statusList.length == 1 || vm.viewSaveObject.amenitiesList.length == 1 || vm.filterObj.SearchText.length == 1)) {
                    vm.viewAttrsChanged = true;
                }
                else {
                    vm.viewAttrsChanged = false;
                }

                vm.getReservationsList();
            },
            deleteSelectedTagFromFilter(index, tagObj) {
                this.removeTagFromFilter(tagObj);
                this.viewSaveObject.tags.splice(index, 1);
                this.applyFilter();
            },
            deleteSelectedUnitFromFilter(index, unitObj) {
                this.removeUnitFromFilter(unitObj);
                this.viewSaveObject.unitList.splice(index, 1);
                this.applyFilter();
            },
            deleteSelectedStatusFromFilter(index, statusObj) {
                this.removeStatusFromFilter(statusObj);
                this.viewSaveObject.statusList.splice(index, 1);
                this.applyFilter();
            },
            deleteSelectedAmenitiesFromFilter(index, amenitiesObj) {
                this.removeAmenitiesFromFilter(amenitiesObj);
                this.viewSaveObject.amenitiesList.splice(index, 1);
                this.applyFilter();
            },
            addColumnToFilters(colObj) {
                let index = this.filterObj.Columns.findIndex((currCol) => {
                    return currCol.colunmName === colObj.ColumnName;
                })
                if (index === -1) {
                    this.filterObj.Columns.push(JSON.parse(JSON.stringify(
                        { colunmName: colObj.ColumnName, label: colObj.Label, value: null, arrText: [], rangeVal: null, type: colObj.Type }
                    )));
                }
            },
            addSearcTextToColumn(filterCol, event) {
                if (event.key == "Enter") {
                    if (filterCol.value != null) {
                        // if(filterCol.colunmName == "ConfirmationNumber" && typeof filterCol.value == 'string'){
                        //     filterCol.value = filterCol.value.replace(/ht/gi, '');
                        // }
                        filterCol.arrText.push(filterCol.value);
                        filterCol.value = null;
                    }
                }
            },
            removeSearchTextFromColumn(selectedText, filterCol) {
                let vm = this;
                // console.log("filterCol", vm.filterObj.Columns)	
                // let index = vm.filterObj.Columns.findIndex((col) => {	
                //   return col.ColumnName == filterCol.ColumnName;	
                // });	
                vm.viewSaveObject = JSON.parse(JSON.stringify(vm.viewSaveObject));
                // if (index > -1) {	
                //   vm.filterObj.Columns[index]["arrText"].splice(vm.filterObj.Columns[index]["arrText"].indexOf(selectedText), 1);	
                //   // console	
                //   // this.removeSearchTextFromColumn(text, viewColObj);	
                // }	

                if (filterCol.arrText.indexOf(selectedText) > -1) {
                    filterCol.arrText.splice(filterCol.arrText.indexOf(selectedText), 1)
                }
                else if (filterCol.rangeVal || filterCol.value) {
                    filterCol.value = null;
                    filterCol.rangeVal = null;
                }
                //this.applyFilter();
            },
            removeSelectedColumnTextFromFilter(text, viewColObj) {
                let index = this.viewSaveObject.columns.findIndex((col) => {
                    return col.ColumnName == viewColObj.ColumnName;
                });
                if (index > -1) {
                    this.viewSaveObject.columns[index]["arrText"].splice(this.viewSaveObject.columns[index]["arrText"].indexOf(text), 1);
                    this.removeSearchTextFromColumn(text, viewColObj);
                }
                this.applyFilter();
            },

            panelCallback(resObj) {
                let vm = this;
                // vm.items = [];
                // vm.filterObj.PageNumber = 1;
                // vm.getReservationsList();
                // vm.$store.state.bus.$emit("ResSummaryUpdate", resObj);
            },

            updateFilterCalendarStartDate(key, dateObj, objectPassedToParent) {
                objectPassedToParent.startdate = dateObj ? dateObj.format("MMMM YYYY") : null;
            },
            //old filter columns dates update functions
            updateFilterStartDate(key, dateObj, objectPassedToParent) {
                objectPassedToParent.value = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            updateFilterEndDate(key, dateObj, objectPassedToParent) {
                objectPassedToParent.rangeVal = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            //old stay dates update functions
            updateFilterStayStartDate(key, dateObj, objectPassedToParent) {
                this.filterObj.stayStartDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            updateFilterStayEndDate(key, dateObj, objectPassedToParent) {
                this.filterObj.stayEndDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            //update function for date-range-picker for stay dates
            updateStayDateValues(value) {
              console.log('value', value);
              this.filterObj.stayStartDate = moment(value.startDate).format('DD MMM YYYY')
              this.filterObj.stayEndDate = moment(value.endDate).format('DD MMM YYYY')
            },
            //update function for date-range-picker for booked dates and checkin/checkout dates
            updateFilterValues(objectPassedToParent){
                objectPassedToParent.value = moment(this.filterColumnsDateRange.startDate).format('DD MMM YYYY');
                objectPassedToParent.rangeVal = moment(this.filterColumnsDateRange.endDate).format('DD MMM YYYY');
            },
            clearAllFilters() {
                this.items = [];
                this.showPropertyList = false,
                    this.showunitList = false,
                    this.showunitTypeList = false,
                    this.showsourceList = false,
                    this.showunitNameList = false,
                    this.showstatusList = false,
                    this.showAmenitiesList = false,
                    this.showtagList = false
                this.scrlBtns = false;
                this.viewAttrsChanged = false;
                this.filterObj.ViewListId = this.filterObj.ViewListId
                this.filterObj = {
                    PropertyId: -99,
                    UnitClassId: -99,
                    ViewListId: this.filterObj.ViewListId,
                    SortBy: null,
                    SortOrder: null,
                    resSourceId: -99,
                    TagsList: [],
                    SearchText: [],
                    Properties: [],
                    UnitClasses: [],
                    UnitTypes: [],
                    rateplanList: [],
                    Sources: [],
                    Units: [],
                    unitList: [],
                    StatusList: [],
                    AmenitiesList: [],
                    Columns: [],
                    PageNumber: 1,
                    ItemsPerPage: 20,
                    startdate: null,
                    Beds: null,
                    Bedrooms: null,
                    Bathrooms: null,
                    stayStartDate: null,
                    stayEndDate: null
                };

                this.viewSaveObject = {
                    viewId: -1,
                    name: null,
                    isPublic: false,
                    entityId: 4,
                    propertyId: -99,
                    UnitClassId: -99,
                    resSourceId: -99,
                    sortColumn: null,
                    sortOrder: null,
                    filters: [],
                    tags: [],
                    columns: [],
                    properties: [],
                    UnitClasses: [],
                    UnitTypes: [],
                    sources: [],
                    units: [],
                    unitList: [],
                    statusList: [],
                    amenitiesList: [],
                    rateplanList: [],
                    startdate: null
                },
                this.stayDateRange.startDate = null, 
                this.stayDateRange.endDate = null, 

                this.filterColumnsDateRange.startDate = null, 
                this.filterColumnsDateRange.endDate = null, 
                
                this.clearfilterForsearchText = false;
                this.parentCallback({ toggleFilterPanel: false, viewSaveObject: this.viewSaveObject, filterObj: this.filterObj, clearFilter: true, fromfile: "filterpanel", viewAttrsChanged: this.viewAttrsChanged })
            },

        },
        computed: {
            fncIsMenuReservations() {
                let vm = this;
                if (vm.$store.state.userEntitlementList.hasOwnProperty("fncMenuReservations")) {
                    return vm.$store.state.userEntitlementList.hasOwnProperty("fncMenuReservations") ? vm.$store.state.userEntitlementList.fncMenuReservations : null;
                }
            },
            fncIsReservationSelect() {
                let vm = this;
                if (vm.$store.state.userEntitlementList.hasOwnProperty("fncReservationSelect")) {
                    return vm.$store.state.userEntitlementList.hasOwnProperty("fncReservationSelect") ? vm.$store.state.userEntitlementList.fncReservationSelect : null;
                }
            },
            fncIsFolioView() {
                let vm = this;
                if (
                    vm.$store.state.userEntitlementList.hasOwnProperty(
                        "fncFolioView"
                    )
                ) {
                    return vm.$store.state.userEntitlementList.hasOwnProperty(
                        "fncFolioView"
                    )
                        ? vm.$store.state.userEntitlementList.fncFolioView
                        : null;
                }
            },
            fncIsReservationUpdate() {
                let vm = this;
                if (
                    vm.$store.state.userEntitlementList.hasOwnProperty(
                        "fncReservationUpdate"
                    )
                ) {
                    return vm.$store.state.userEntitlementList.hasOwnProperty(
                        "fncReservationUpdate"
                    )
                        ? vm.$store.state.userEntitlementList.fncReservationUpdate
                        : null;
                }
            },
            fncIsReservationReports() {
                let vm = this;
                if (
                    vm.$store.state.userEntitlementList.hasOwnProperty(
                        "fncReservationReports"
                    )
                ) {
                    return vm.$store.state.userEntitlementList.hasOwnProperty(
                        "fncReservationReports"
                    )
                        ? vm.$store.state.userEntitlementList.fncReservationReports
                        : null;
                }
            },


            showpDropdownList() {
                setTimeout(function () {
                    this.selectedFilterColumn = !this.selectedFilterColumn
                    $("#propertyDropDownlist").show();
                }, 10);
            },

        },
        watch: {
            loading() {
                this.$store.state.bus.$emit('reservationListLoading', this.loading);
            },
            items(newArr, oldArr) {
                console.log("items changed", oldArr, newArr);
            },
            viewSaveObject: {
                handler: function (after, before) {
                    console.log(this.viewSaveObject)
                    if (this.viewSaveObject.viewId === -1 && this.viewSaveObject.name === null &&
                        this.viewSaveObject.isPublic === false && this.viewSaveObject.entityId === 4 &&
                        this.viewSaveObject.propertyId === -99 && this.viewSaveObject.UnitClassId === -99 &&
                        this.viewSaveObject.resSourceId === -99 && this.viewSaveObject.sortColumn === null &&
                        this.viewSaveObject.sortOrder === null && this.viewSaveObject.filters.length === 0 &&
                        this.viewSaveObject.tags.length === 0 && this.viewSaveObject.columns.length === 0 &&
                        this.viewSaveObject.properties.length === 0 && this.viewSaveObject.UnitClasses.length === 0 &&
                        this.viewSaveObject.sources.length === 0 && this.viewSaveObject.unitList.length === 0 &&
                        this.viewSaveObject.statusList.length === 0 && this.viewSaveObject.amenitiesList.length === 0
                    ) {
                        console.log("no change in view object");
                        this.viewObjectChanged = false;
                    }
                    else {
                        console.log("change in view object");
                        this.viewObjectChanged = true;
                    }
                },
                deep: true,
            },

            filterSearchTagText(newValue, oldValue) {
                let vm = this;
                // if (newValue)
                vm.getClientTags(newValue);
            },
            filterSearchPropertyText(newValue, oldValue) {
                this.getPropertiesBySearchText(newValue);
            },
            filterSearchUnitClassText(searchText) {
                // if (searchText) {
                this.GetUnitClasssListBySearchText(searchText);
                // }
            },
            filterSearchUnitTypeText(searchText) {
                // if (searchText) {
                this.GetUnitTypeListBySearchText(searchText);
                // }
            },
            filterSearchRateplan(searchText) {
                // if (searchText) {
                this.getRatePlanDetailList(searchText);
                // }
            },
            filterSearchSourceTypeText(searchText) {
                // if (searchText) {
                this.getSourceListBySearchText(searchText);
                // }
            },
            filterSearchUnitNameText(searchText) {
                // if (searchText) {
                this.getUnitNamesBySearchText(searchText);
                // }
            },
            filterSearchUnitList(searchText) {
                // if (searchText) {
                this.getUnitNamesBySearchText(searchText);
                // }
            },
            filterSearchStatusText(searchText) {
                // if (searchText) {
                this.getStatusBySearchText(searchText);
                // }
            },
            filterSearchAmenitiesText(searchText) {
                this.getAmenetiesByClient(searchText);
            }
        },
        mounted() {

            $(document).click(function (e) {
                console.log("clicked on doc");
                $("#propertyDropDownlist").show();
                // vm.showLedgerAccounts = false;
                // vm.showAmenitiesList =false;
            });


            let vm = this;

            vm.GetUserEntitlementsAndDefaultProperty();
            vm.getRatePlanDetailList();

            $(this.$el).find("ul.dropdown-menu").click(function (e) {
                e.stopPropagation();
            });
            $(document).click(function (e) {
                $(".form-control.searchResultsAmenities").hide();
                vm.selectedFilterColumn = null;
            })
        },
        components: {

        },
        init() {
            console.log("created filter list");
        },
        beforeDestroy() {
        }
    };

</script>